export default __webpack_public_path__ + "static/media/designSolution.041db3aa.jpg";